import { render, staticRenderFns } from "./UserCourses.vue?vue&type=template&id=124ca71e&scoped=true"
import script from "./UserCourses.vue?vue&type=script&lang=js"
export * from "./UserCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ca71e",
  null
  
)

export default component.exports